/** @typedef {string} CheckboxInputLabelPosition */
export const CHECKBOX_INPUT_LABEL_POSITION_LEFT = 'left';
export const CHECKBOX_INPUT_LABEL_POSITION_RIGHT = 'right';
/** @enum {CheckboxInputLabelPosition} */
export const CHECKBOX_INPUT_LABEL_POSITION = {
	LEFT: CHECKBOX_INPUT_LABEL_POSITION_LEFT,
	RIGHT: CHECKBOX_INPUT_LABEL_POSITION_RIGHT
};
/** @type {CheckboxInputLabelPosition[]} */
export const CHECKBOX_INPUT_LABEL_POSITIONS = [CHECKBOX_INPUT_LABEL_POSITION_LEFT, CHECKBOX_INPUT_LABEL_POSITION_RIGHT];